

// import aiAxiosInstance from "../../apiAxios/aiAxiosInstance";
import aiAxiosInstance from "../../apiAxios/axiosInstance";

// Start AI Call
// export const startAiCall = async (payload) => {
//     const response = await aiAxiosInstance.post(
//         "vendor/campaign",
//         payload
//     );

//     return response.data;
// };

export const startAiCall = async (payload) => {
    const response = await aiAxiosInstance.post(
        "/vendor/vendor-multiple-lead-call",
        payload
    );

    return response.data;
};

export const startAiCallByLeadType = async (payload) => {
    const response = await aiAxiosInstance.post(
        "/vendor/vendor-multiple-lead-call-leadtype",
        payload
    );

    return response.data;
};

export const AiCallList = async (payload) => {
    const response = await aiAxiosInstance.get(
        "/vendor/vendor-multiple-lead-call-get",
        payload
    );

    return response.data;
};
export const AiCallQuestionsList = async (payload) => {
    const response = await aiAxiosInstance.post(
        "/vendor/training-questions",
        payload
    );

    return response.data;
};
export const AiCallAnswerList = async (payload) => {
    const response = await aiAxiosInstance.post(
        "/vendor/training-answer",
        payload
    );

    return response.data;
};

export const AiCallListByLeadType = async (leadType, payload) => {
    const url =
        leadType === "investment"
            ? "/vendor/vendor-investment-multiple-lead-call-get"
            : "/vendor/vendor-work-multiple-lead-call-get";

    const response = await aiAxiosInstance.get(url, { params: payload });
    return response.data;
};

export const getVendorCallbacks = async (payload) => {
    const response = await aiAxiosInstance.post(
        "/vendor/vendor-callbacks-call-get",
        payload
    );
    return response.data;
};

// export const viewCallDetail = async (phone) => {
//     const response = await aiAxiosInstance.get(
//         `vendor/lead/${phone}`,
//     );

//     return response.data;
// };

export const viewCallDetail = async (phone) => {
      const encoded = encodeURIComponent(phone); 
    const response = await aiAxiosInstance.get(
        `/vendor/vendor-single-call-history/${encoded}`,
    );

    return response.data;
};

// export const getAiCallHistory = async (payload) => {
//     const response = await aiAxiosInstance.get(
//         "vendor/results/22222222-2222-2222-2222-222222222222",
//         payload
//     );

//     return response.data;
// };

export const getAiCallHistory = async (payload) => {
    const response = await aiAxiosInstance.get(
        "/admin/demo-calling-client-get",
        payload
    );

    return response.data;
};